import React, { useState } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { TabView, TabPanel } from 'primereact/tabview';

type Props = {
  encodeOn: boolean;
  value: string;
  setValue: (input: string) => void;
  byteVersion: number[] | undefined;
}

const InputTextBox = ({ encodeOn, value, setValue, byteVersion }: Props) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  console.log(byteVersion)

  return (
    <div className='inputTextBox'>
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header="Text">
          <span className="p-float-label inputTextContainer">
            {/* keyfilter="alpha" for chars only */}
            <InputTextarea id="inputtext" maxLength={800} value={value} onChange={(e) => setValue(e.target.value) } rows={5} 
            />
            {encodeOn ?
              <label htmlFor="inputtext">Plain Text</label>
              :
              <label htmlFor="inputtext">Cipher Text</label>
            }
          </span>

        </TabPanel>
        <TabPanel header="Byte">
          <span className="p-float-label inputTextContainer">
            <InputTextarea id="inputtext" value={byteVersion ? byteVersion.map(byte => byte.toString(16).padStart(2, '0')).join(" ") : ""}
              rows={5} />
            <label htmlFor="inputtext">Byte View</label>
          </span>
        </TabPanel>
      </TabView>
    </div>
  )
}

export default InputTextBox